import React from 'react';
import './PrivacyAndPolicy.css'
import noonlogo from './noonlogo.png'

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
    <div className="privacy-policy">
      <h2>Privacy Policy</h2>
      <ol>
        <li>
          <h3>Information Collection and Use</h3>
          <p>We respect your privacy and are committed to protecting your personal information. The Mutabaah app collects certain data to provide its services efficiently. This information is used solely for the purposes outlined in this policy and will not be shared with third parties except as outlined herein or with your explicit consent.</p>
          <h4>Data Collection:</h4>
          <ul>
            <li><strong>User-Provided Information:</strong> The Mutabaah app may collect and store information you provide when using the app, including but not limited to names, email addresses, profile pictures, and attendance records.</li>
            <li><strong>Automatically Collected Information:</strong> The app may also collect certain information automatically, such as device information, usage statistics, and diagnostic data. This information is used to improve app performance and user experience.</li>
            <li><strong>Exported Data:</strong> The app allows users to export data to PDF and CSV formats. Any data exported by the user is stored locally on the device and is not transmitted to our servers unless explicitly shared by the user.</li>
          </ul>
        </li>
        <li>
          <h3>Data Usage</h3>
          <p><strong>Purpose of Data Collection:</strong></p>
          <ul>
            <li><strong>Attendance Management:</strong> The primary purpose of data collection is to facilitate attendance management for teachers and educators. The app allows users to record and track student attendance efficiently.</li>
            <li><strong>Data Memorization:</strong> The app provides features to help users manage and track student memorization progress. This includes recording memorization sessions, setting goals, and tracking progress over time.</li>
            <li><strong>Export Functionality:</strong> Users have the option to export data to PDF and CSV formats for their own use. This feature is designed to provide users with flexibility and convenience in managing their data.</li>
          </ul>
        </li>
        <li>
          <h3>Data Security</h3>
          <p>We take appropriate measures to safeguard the data collected by the Mutabaah app and ensure its security. This includes implementing encryption, access controls, and other industry-standard security practices to protect against unauthorized access, disclosure, alteration, or destruction of your personal information.</p>
        </li>
        <li>
          <h3>Data Sharing</h3>
          <p><strong>Third-Party Services:</strong> The Mutabaah app may integrate with third-party services, such as cloud storage providers, for enhanced functionality. Any data shared with third-party services is subject to their respective privacy policies.</p>
          <p><strong>Legal Requirements:</strong> We may disclose personal information if required to do so by law or in response to valid legal requests, such as court orders or subpoenas.</p>
        </li>
        <li>
          <h3>User Controls and Choices</h3>
          <p><strong>Data Access and Modification:</strong> Users can access, review, and modify their personal information stored within the app. This includes attendance records, memorization progress, and profile information.</p>
          <p><strong>Data Deletion:</strong> Users have the option to delete their data stored within the app. Deleting data may impact the functionality of certain features, and any data exported by the user will remain stored locally on the device.</p>
        </li>
        <li>
          <h3>Contact Us</h3>
          <p>If you have any questions, concerns, or feedback regarding this privacy policy or the handling of your personal information, please contact us at <a href="mailto:bbambangg95@gmail.com">bbambangg95@gmail.com</a>.</p>
        </li>
        <li>
          <h3>Changes to this Policy</h3>
          <p>We reserve the right to update or modify this privacy policy at any time. Any changes will be reflected on this page, and we encourage you to review this policy periodically for updates.</p>
        </li>
      </ol>
      <p>
        By using the Mutabaah app, you consent to the collection, use, and sharing of your information as described in this privacy policy. If you do not agree with this policy, please do not use the app.
      </p>
      <p>
        Last updated: 6 April 2024
      </p>
    </div>
    </div>
  );
}

export default PrivacyPolicy;
